import axiosInstance from '@/api/config.js';

export const staffService = {
  async searchStaff(params = {}) {
    return await axiosInstance.get('/api/staff/search', { params });
  },

  /**
   * 取得目前登入者的人員資料
   * @returns {Promise<Object>}
   */
  async getMe() {
    return await axiosInstance.get('/api/staff/me');
  },
};
